import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { SubscriptionsService } from '../services/subscriptions.service';

export const writerPlansGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const subs = inject(SubscriptionsService);

  if (!auth.isAuthenticated) {
    sessionStorage.setItem('postAuthIntent', 'writer');
    router.navigate(['/register'], { queryParams: { intent: 'writer' } });
    return false;
  }

  return subs.hasActiveWriterSubscription().pipe(
    map(hasActive => {
      if (hasActive) {
        router.navigate(['/publish-book']);
        return false;
      }
      return true;
    }),
    catchError(() => of(true))
  );
};
